module.exports = __webpack_public_path__ + "static/window-ba4e2b024b18df9a4f07f67b922ef96b.png";